import { i18nKeys } from 'translationTypes'
import i18n from '../../../../../i18n'

export default {
  title: () => i18n.t(i18nKeys.signupForm__title),
  alreadySignedUp: () => i18n.t(i18nKeys.signupForm__alreadySignedUp),
  finishSigningUp: () => i18n.t(i18nKeys.signupForm__finishSigningUp),
  hasCheckedAgreement: () => i18n.t(i18nKeys.signupForm__hasCheckedAgreement),
  signUp: () => i18n.t(i18nKeys.common__signUp),
  getStarted: () => i18n.t(i18nKeys.common__getStarted),
  email: () => i18n.t(i18nKeys.common__email),
  phone: () => i18n.t(i18nKeys.common__phone),
  zipcode: () => i18n.t(i18nKeys.common__zipcode),
  CALegal: () => i18n.t(i18nKeys.signupForm__CALegal),
  legal: () => i18n.t(i18nKeys.signupForm__legal),
  title1of3: () => i18n.t(i18nKeys.signupForm__title1of3),
  title2of3: () => i18n.t(i18nKeys.signupForm__title2of3),
  title3of3: () => i18n.t(i18nKeys.signupForm__title3of3),
  subtitle: () => i18n.t(i18nKeys.signupForm__subtitle),
}
